import { Language } from '@coolblue-development/constants';
import { nextPickupOption, StoreSchedules } from '@features/product/typings';

import parseAcceptTime from './parseAcceptTime';

const AMSTERDAM_TIMEZONE = 'Europe/Amsterdam';

const getNextPickupOption = (
  openingHours: StoreSchedules[],
  date: Date,
  language: Language
): nextPickupOption | null => {
  const { currentDate } = getCurrentDateTimeInTimeZone(AMSTERDAM_TIMEZONE, date);

  for (const openingHour of openingHours) {
    const { acceptTime, nextPickupDateTime, scheduleDate } = openingHour;

    const schedule = new Date(scheduleDate);
    schedule.setHours(0, 0, 0, 0);
    const today = new Date(currentDate);
    today.setHours(0, 0, 0, 0);

    if (schedule < today) continue;

    const { hour, minute, second } = parseAcceptTime(acceptTime);

    const cutoffDate = new Date(currentDate);
    cutoffDate.setHours(hour, minute, second, 0);

    const scheduleIsToday = schedule.getTime() === today.getTime();
    const pastCutoffTime = currentDate >= cutoffDate;

    if (scheduleIsToday && pastCutoffTime) continue;

    const pickupDate = new Date(nextPickupDateTime);
    const isTomorrow = pickupDate.toDateString() === addDays(today, 1).toDateString();

    const localizedDayName = pickupDate.toLocaleDateString(`${language}-US`, {
      weekday: 'long'
    });

    const hours = pickupDate.getHours().toString().padStart(2, '0');
    const minutes = pickupDate.getMinutes().toString().padStart(2, '0');

    return {
      pickupTime: `${hours}:${minutes}`,
      isTomorrow,
      localizedDayName
    };
  }

  return null;
};

const getCurrentDateTimeInTimeZone = (timeZone: string, date: Date): { currentDate: Date } => {
  const localDate = new Date(date.toLocaleString('en-US', { timeZone }));
  return {
    currentDate: localDate
  };
};

const addDays = (date: Date, days: number): Date => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

export default getNextPickupOption;
